import api from "./api";

const VehicleHireService = {
  // CREATE vehicle hire
  create: async (data) => {
    const response = await api.post("/vehicleHire/save", data);
    return response.data;
  },


  // getAll: async () => {
  //   const response = await api.get("/vehicleHire/getAll");
  //   return response.data;
  // },

  getAll: async (companyId, pageNumber, noOfRows, search = "") => {
    const response = await api.get(
      `/vehicleHire/getAll?companyId=${companyId}&pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}`
    );
    return response.data.data;
  },


  getByCompanyId: async (companyId) => {
    const res = await api.get(`/vehicleHire/getByCompany/${companyId}`);
    return res.data;
  },

  // GET vehicle hire by ID
  getById: async (id) => {
    const response = await api.get(`/vehicleHire/getById/${id}`);
    return response.data;
  },

  getByVehicleTypeId: async (vehicleTypeId) => {
    const response = await api.get(`/vehicleHire/getByVehicleTypeId/${vehicleTypeId}`);
    return response.data;
  },
  //Transfer Vehicle requests
  getTransferVehicles: async (companyId, vehicleTypeId, projectId) => {
    const response = await api.get(`/vehicleHire/getTransferVehicles/${companyId}/${vehicleTypeId}/${projectId}`);
    return response.data;
  },

  // UPDATE vehicle hire
  update: async (id, data) => {
    const response = await api.put(`/vehicleHire/update/${id}`, data);
    return response.data;
  },

  // DELETE vehicle hire
  remove: async (id) => {
    const response = await api.delete(`/vehicleHire/${id}`);
    return response.data;
  },

  // GET active vehicle hires
  getActive: async () => {
    const response = await api.get("/vehicleHire/getActive");
    return response.data;
  },

  updateStatus: async (id) => {
    const response = await api.put(`/vehicleHire/updateStatus/${id}`);
    return response.data;
  },

  // EXPORT vehicle hire (ALL records)
  exportVehicleHire: async (companyId) => {
    const response = await api.get(`/vehicleHire/export?companyId=${companyId}`);
    return response.data;
  },

};

export default VehicleHireService;
